import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import AuthCard from '../../../components/ui/cards/AuthCard'
import NavBar from '../../../components/ui/navigation/NavBar'
import ForgotPasswordForm from './components/ForgotPasswordForm'

class UnauthenticatedForgotPasswordIndex extends Component {
  render() {
    return (
      <div>
        <NavBar />
        <div className="container">
          <div className="max-600">
            <AuthCard
              delay={0.5}
              title="Reset your Password"
              subtitle=""
            >
              <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-md-10 offset-md-1">
                  <ForgotPasswordForm />
                  <br/>
                  <Link to="/login">Login</Link>
                </div>
              </div>
            </AuthCard>
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(UnauthenticatedForgotPasswordIndex)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/ForgotPassword/UnauthenticatedForgotPasswordIndex.js